var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Indikator Pelayanan")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "year" },
            },
            [_vm._v("Tahun")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c("v-select", {
                attrs: {
                  clearable: false,
                  multiple: false,
                  options: _vm.data_year,
                  label: "name",
                  name: "year",
                  id: "year",
                  placeholder: "Pilih Tahun",
                  single: true,
                },
                on: {
                  input: function ($event) {
                    return _vm.setYear($event)
                  },
                },
                model: {
                  value: _vm.year,
                  callback: function ($$v) {
                    _vm.year = $$v
                  },
                  expression: "year",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "col-sm-8 text-end" }, [
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.getPel } },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v("\n                        Cari"),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "card mb-3" }, [
      _c("div", { staticClass: "card-header text-white bg-primary" }, [
        _vm._v("Data Indikator Pelayanan"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table" } }, [
          _c(
            "table",
            { staticClass: "table table-bordered" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.data_pel, function (item, index) {
                return _c("tbody", { key: index }, [
                  _c("tr", [
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.bulan) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _vm.jumlahHariPerawatan > 0 && _vm.pembagiBOR > 0
                          ? [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    Math.ceil(
                                      (_vm.jumlahHariPerawatan /
                                        _vm.pembagiBOR) *
                                        100
                                    )
                                  ) +
                                  " %\n                                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                                    0 %\n                                "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _vm.jumlahHariPerawatan > 0 &&
                        item.jumlahPasienKeluar > 0
                          ? [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    Math.ceil(
                                      _vm.jumlahHariPerawatan /
                                        item.jumlahPasienKeluar
                                    )
                                  ) +
                                  " Hari\n                                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                                    0 Hari\n                                "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _vm.jumlahHariPerawatan > 0 &&
                        item.jumlahTempatTidur > 0
                          ? [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    Math.ceil(
                                      _vm.jumlahHariPerawatan /
                                        item.jumlahTempatTidur
                                    )
                                  ) +
                                  " Hari\n                                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                                    0 Hari\n                                "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _vm.jumlahHariPerawatan > 0 &&
                        item.jumlahPasienKeluar > 0 &&
                        item.jumlahTempatTidur > 0
                          ? [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    Math.ceil(
                                      (item.jumlahTempatTidur *
                                        _vm.jumlahPeriode -
                                        _vm.jumlahHariPerawatan) /
                                        item.jumlahPasienKeluar
                                    )
                                  ) +
                                  " Hari\n                                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                                    0 Hari\n                                "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        item.jumlahPasienMeninggalLebihPatdelapan > 0 &&
                        item.jumlahPasienKeluar > 0
                          ? [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    Math.ceil(
                                      item.jumlahPasienMeninggalLebihPatdelapan /
                                        item.jumlahPasienKeluar
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                                    0\n                                "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        item.jumlahPasienMeninggal > 0 &&
                        item.jumlahPasienKeluar > 0
                          ? [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    Math.ceil(
                                      item.jumlahPasienMeninggal /
                                        item.jumlahPasienKeluar
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          : [
                              _vm._v(
                                "\n                                    0\n                                "
                              ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                0\n                            "
                      ),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Bulan")]),
        _vm._v(" "),
        _c("th", [_vm._v("BOR")]),
        _vm._v(" "),
        _c("th", [_vm._v("LOS")]),
        _vm._v(" "),
        _c("th", [_vm._v("BTO")]),
        _vm._v(" "),
        _c("th", [_vm._v("TOI")]),
        _vm._v(" "),
        _c("th", [_vm._v("NTR")]),
        _vm._v(" "),
        _c("th", [_vm._v("GDR")]),
        _vm._v(" "),
        _c("th", [_vm._v("Rata-rata Kunjungan")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }